<template>
<transition name="modalAnim">
  <div class="div_modalAnim">
    <div class="modal_layer">
      <div class="modal_container">
        <div @click="modalOff" class="xOff">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
            </svg>
          </span>
        </div>
        <div class="modal_item">
            <slot></slot>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
export default {
  props: ['off'],
  data () {
    return {

    }
  },
  methods: {
    modalOff() {
      this.$emit('off')
    }
  },
}
</script>

<style>
 .modal_layer {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
 }
 .modal_container {
    width: 90%;
    height: 90vh;
    /*background: #78909C;*/
    background: rgba(13, 14, 44, 0.95);
    border-radius: 0.2rem;
    padding: 4rem 1rem 1rem 1rem;
    position: relative;
   box-shadow: 0 0 10px #FF497A, 0 0 20px #511B75;
 }
 .xOff {
    margin: 0;
    padding: 0;
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #fff;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /*background: #78909C;
    border: 1px solid #fff;
    border-radius: 999px;*/
    cursor: pointer;
    font-weight: bold;
    transition: 0.5s;
 }
 .xOff > span {
    padding: 0;
    margin: 0;
 }
 .xOff:hover {
    background: #ff5d5d;
 }
 .modal_item {
   background: linear-gradient(135deg, #1a1a2e, #2e2e48);
    height: 100%;
    border-radius: 0.2rem;
    position: relative;
    width: 100%;
    padding: 2rem 1.5rem 1rem 1.5rem;
    overflow-y: auto;
    max-height: calc(100vh - 68px);
   color: #fff;
 }
.div_modalAnim {
    position: absolute;
    animation: anim_modal_start .3s;
}

 @media (max-width: 767px) {
     .modal_container {
        width: 100%;
     }
 }
</style>



// WEBPACK FOOTER //
// src/components/modal.vue